import React from 'react';
import { Activity, Info, HeartPulse, ClipboardList } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 grid grid-cols-[minmax(0,1fr)_auto] lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-x-3 gap-y-3 py-3">
        <Link to="/" data-testid="header-home-link" className="flex items-center gap-3 min-w-0">
          <div className="flex shrink-0 items-center justify-center w-10 h-10 bg-primary rounded-lg">
            <Activity className="w-6 h-6 text-primary-foreground" />
          </div>
          <div className="min-w-0">
            <span className="text-base sm:text-lg font-bold text-foreground">Anamnese Generator</span>
            <p className="text-xs text-muted-foreground">ABCDE & SAMPLER Schema</p>
          </div>
        </Link>
        <nav aria-label="Hauptnavigation" data-testid="main-navigation" className="col-span-2 row-start-2 lg:col-span-1 lg:row-start-1 lg:col-start-2 w-full grid grid-cols-2 gap-2 border-t lg:border-0 pt-3 lg:pt-0">
          {[
            { to: '/', label: 'Anamnese', icon: ClipboardList, testId: 'anamnesis-nav-link' },
            { to: '/ekg-hilfe', label: 'EKG-Hilfe', icon: HeartPulse, testId: 'ekg-nav-link' }
          ].map(item => <NavLink key={item.to} to={item.to} end data-testid={item.testId} className={({ isActive }) => `flex min-w-0 items-center justify-center gap-2 px-3 py-2 min-h-11 text-sm rounded-md border transition-colors ${isActive ? 'bg-teal-700 border-teal-700 text-white font-semibold' : 'border-teal-700/30 bg-white text-teal-800 hover:bg-primary/10'}`}><item.icon size={16} className="shrink-0" />{item.label}</NavLink>)}
        </nav>
        
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button data-testid="header-storage-info-button" aria-label="Informationen zur lokalen Speicherung" className="col-start-2 row-start-1 lg:col-start-3 justify-self-end p-3 hover:bg-muted rounded-lg transition-colors">
                <Info className="w-5 h-5 text-muted-foreground" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="bottom" className="max-w-xs">
              <p className="text-sm">
                Alle Daten werden lokal gespeichert und automatisch nach 15 Minuten Inaktivität gelöscht.
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </header>
  );
};

export default Header;
